import React, { Component } from 'react';
import { Link } from "react-router-dom";


class Footer extends Component {
    state = {  } 
    render() { 
        return (
            <div className='w-100 ' style={{backgroundColor: '#003968'}} >
                <div className='container-fluid'>
                    <div className='row text-white' >
                        {/* <div className='col-12 col-sm m-2'>
                            <Link to="/termsOfUse" className="text-decoration-none h6">Terms</Link> 
                        </div> */}
                        <div className='col-12 col-sm p-1'>
                            <Link to="/privacyPolicy" className="text-decoration-none h6">
                                <div className={this.props.onEngLanguage()}><div className='p-1'>Privacy policy</div></div>
                                <div className={this.props.onGeoLanguage()}><div className='px-1 py-1 px-sm-0 px-md-1' style={{fontSize:'0.9rem'}}>კონფიდენციალურობა</div></div>
                            </Link>
                        </div>
                        <div className='col-12 col-sm p-1'> 
                            <Link to="/usefulLinks" className="text-decoration-none h6">
                                <div className={this.props.onEngLanguage()}><div className='p-1'>Useful Links</div></div>
                                <div className={this.props.onGeoLanguage()}><div className='px-1 py-1 px-sm-0 px-md-1' style={{fontSize:'0.9rem'}}>სასარგებლო ლინკები</div></div>
                            </Link>
                        </div>
                        <div className='col-12 col-sm p-1'>
                            <Link to="/faq" className="text-decoration-none h6">
                                <div className={this.props.onEngLanguage()}><div className='p-1'>FAQ</div></div>
                                <div className={this.props.onGeoLanguage()}><div className='px-1 py-1 px-sm-0 px-md-1' style={{fontSize:'0.9rem'}}>კითხვა-პასუხი</div></div>
                            </Link>
                        </div>
                        <div className='col-12 col-sm p-1'>
                            <Link to="/contact" className="text-decoration-none h6">
                                <div className={this.props.onEngLanguage()}><div className='p-1'>Contact us</div></div>
                                <div className={this.props.onGeoLanguage()}><div className='px-1 py-1 px-sm-0 px-md-1' style={{fontSize:'0.9rem'}}>კონტაქტი</div></div>
                            </Link>
                        </div>
                    </div>
                </div>
                
              
            </div>
        );
    }
}
 
export default Footer;